// src/constants/config.js
export const IMAGE_BASE_URL =
  "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod";